<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <event-storming-model-canvas v-if="small"
                                 :key="componentKey"
                                 :sliderLocationScale="0.5"
                                 elementListBeanPath="classDefinitions"
                                 relationListBeanPath="relations"
                                 relationVueComponentName="class-relation"
                                 ref="designer"
                                 v-model="value.result"
                                 :projectTitle="projectName"
                                 @change="onResultChange"
                                 @codeChange="onCodeChange"
                                 is-read="true"
                                 class="small"
                                 :projectId="loadProjectId"
                                 @newProjectId="setLoadProjectId"
                                 fork
    ></event-storming-model-canvas>

    <event-storming-model-canvas v-else
                                 :key="componentKey"
                                 elementListBeanPath="classDefinitions"
                                 relationListBeanPath="relations"
                                 relationVueComponentName="class-relation"
                                 ref="designer"
                                 v-model="value.result"
                                 :projectTitle="projectName"
                                 @change="onResultChange"
                                 @codeChange="onCodeChange"
                                 :labId="labInfo.labId"
                                 :projectId="loadProjectId"
                                 @newProjectId="setLoadProjectId"
                                 fork
    ></event-storming-model-canvas>
</template>

<script>
    import EventStormingModelCanvas from "../../designer/es-modeling/EventStormingModelCanvas";

    var jp = require('jsonpath');

    export default {
        name: 'lab-tool-event-designer',
        props: {
            value: Object,
            //readonly: Boolean,
            small: Boolean,
            labInfo: Object
        },
        components:{EventStormingModelCanvas},
        data() {
            return {
                //result: {definition:[], relation:[]},
                componentKey: 0,
                projectName: '',
                loadProjectId: null ,
                url: '',
                elementTypes: [
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'domain-event-definition',
                        'label': 'Event',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/event.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'command-definition',
                        'label': 'Command',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/command.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'policy-definition',
                        'label': 'Policy',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/policy.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'aggregate-definition',
                        'label': 'Aggregate',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/aggregate.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'external-definition',
                        'label': 'External',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/external.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'view-definition',
                        'label': 'View',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/view.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'bounded-context-definition',
                        'label': 'Bounded Context',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/bounded2.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-actor-none',//'OG.shape.essencia.Alpha',
                        'component': 'actor-definition',
                        'label': 'Actor',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/actor.png`
                    },
                ],
            }
        },
        watch: {
            // value: {
            //     deep:true,
            //     handler(newVal) {
            //
            //         if(!newVal.relations) {
            //             newVal.relations = {}
            //         }
            //         console.log(JSON.stringify(newVal))
            //         this.$emit('change', newVal);
            //     }
            //
            // }
        },
        created: function () {
            if (this.value.result == null) {
                this.value.result = {elements: {}, relations: {}};
            }
        },
        mounted: function () {
            var me = this;
            setTimeout(() => {
                me.$EventBus.$emit('progressValue', false)
            }, 2000)
            if(me.labInfo && me.labInfo.modelUrl){
                me.loadProjectId = me.labInfo.modelUrl
            }

        },
        methods: {
            setLoadProjectId(newProjectId){

                this.loadProjectId = newProjectId ? newProjectId : null
                // force Render
                this.componentKey += 1;
            },
            onResultChange(change,projectName) {
                var me = this
                this.value.result = change;
                if (change && change.projectName) {
                    me.projectName = change.projectName
                }else{
                    me.projectName = projectName
                }

                this.$emit('input', this.value);
                this.$emit('change', this.value);

            },
            onCodeChange(change) {
                this.value.code = change;
                this.value.modelForElements = change.modelForElements;
                this.value.rootModel = change.rootModel;

                this.$emit('input', this.value);
                this.$emit('change', this.value);

            },

            //for user checkpoint expressions
            query(exp) {
                return jp.query(this.value.modelForElements, exp);
            }
        }
    }
</script>


<style scoped lang="css" rel="stylesheet/css">

    .canvas-panel.small {
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }

</style>



